import { render } from "./qiankunMenu.vue?vue&type=template&id=3b88ec79&scoped=true"
import script from "./qiankunMenu.vue?vue&type=script&lang=js"
export * from "./qiankunMenu.vue?vue&type=script&lang=js"

import "./qiankunMenu.vue?vue&type=style&index=0&id=3b88ec79&lang=less"
import "./qiankunMenu.vue?vue&type=style&index=1&id=3b88ec79&lang=less&scoped=true"
import "./qiankunMenu.vue?vue&type=style&index=2&id=3b88ec79&lang=css"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b88ec79"]])

export default __exports__